import { getProductTitle } from './get-product-title.js';
import { isContactLensesOrderLineItem } from './order-line-item-product-type-guards.js';

function getLensAttrLabel(intl, key) {
    const PREFIX = 'products.contactLenses';
    const opts = {
        hideLabelKey: true
    };
    return ({
        power: intl.getLabel(`${PREFIX}.prescription.power`, opts),
        baseCurve: intl.getLabel(`${PREFIX}.prescription.baseCurve`, opts),
        diameter: intl.getLabel(`${PREFIX}.prescription.diameter`, opts),
        cylinder: intl.getLabel(`${PREFIX}.prescription.cylinder`, opts),
        axis: intl.getLabel(`${PREFIX}.prescription.axis`, opts),
        addition: intl.getLabel(`${PREFIX}.prescription.addition`, opts),
        left: intl.getLabel(`${PREFIX}.leftEye`, opts),
        right: intl.getLabel(`${PREFIX}.rightEye`, opts),
        both: ''
    })[key];
}
const makeContactLensA11yLabel = (lineItem, a11yLabel, intl)=>{
    if (!lineItem.prescription) {
        return a11yLabel;
    }
    const { eyeSide  } = lineItem;
    const { power , baseCurve , diameter , cylinder , axis , addition  } = lineItem.prescription;
    // prepend label with eyeSide if eyeSide is 'left' or 'right'
    if (eyeSide) {
        const attr = getLensAttrLabel(intl, eyeSide.toLowerCase());
        a11yLabel = [
            attr,
            a11yLabel
        ].join(', ');
    }
    const lensAttributes = {
        power,
        baseCurve,
        diameter,
        cylinder,
        axis,
        addition
    };
    return Object.entries(lensAttributes).reduce((acc, [key, value])=>{
        const label = getLensAttrLabel(intl, key);
        if (!label || !value) {
            return acc;
        }
        return acc + `, ${label}: ${value}`;
    }, a11yLabel);
};
function getProductA11yLabel(lineItem, intl, quantity) {
    const quantityLabel = intl.getLabel('cart.item.quantity');
    let a11yLabel = getProductTitle(lineItem, intl);
    if (quantity) {
        a11yLabel += `, ${quantityLabel}: ${quantity}`;
    }
    if (isContactLensesOrderLineItem(lineItem)) {
        a11yLabel = makeContactLensA11yLabel(lineItem, a11yLabel, intl);
    }
    return a11yLabel;
}

export { getProductA11yLabel };
//# sourceMappingURL=get-product-a11y-label.js.map
